import type { TextFieldProps } from '@mui/material';

export const BLOCK_TEXT_FIELD_PROPS: Partial<TextFieldProps> = {
  variant: 'outlined',
  size: 'small',
  fullWidth: true,
};

export const BLOCK_SHORT_TEXTAREA_PROPS: Partial<TextFieldProps> = {
  ...BLOCK_TEXT_FIELD_PROPS,
  multiline: true,
  minRows: 2,
};

export const BLOCK_LONG_TEXTAREA_PROPS: Partial<TextFieldProps> = {
  ...BLOCK_TEXT_FIELD_PROPS,
  multiline: true,
  minRows: 3,
};
